define.alias("shared/components/shared/app-footer", "settings/components/shared/app-footer");